import ApplicationStart from './applicationStart/ApplicationStart';
import LoanPurposes from './loanPurposes/LoanPurposes';
import BorrowingPower from './borrowingPower/BorrowingPower';
import SubLoanPurpose from './subLoanPurpose/SubLoanPurpose';
import BorrowingInput from './borrowingInput/BorrowingInput';
import DebtConsolidation from './debtConsolidation/DebtConsolidation';
import Sorry from './error/Error';

export default {
    Sorry: {
        isBlockDisplay: false,
        headerMain: 'Borrowing power calculator',
        headerContent: 'Get started',
        Component: Sorry,
        prev: null,
        forcePrev: false,
        next: null,
    },
    ApplicationStart: {
        isBlockDisplay: false,
        headerMain: 'Borrowing power calculator',
        headerContent: 'Get started',
        Component: ApplicationStart,
        prev: null,
        forcePrev: false,
        next: 'LoanPurposes',
    },
    LoanPurposes: {
        isBlockDisplay: false,
        headerMain: 'How much can I borrow?',
        headerContent: '',
        Component: LoanPurposes,
        forcePrev: false,
        prev: 'ApplicationStart',
        next: 'SubLoanPurpose',
    },
    SubLoanPurpose: {
        isBlockDisplay: false,
        Component: SubLoanPurpose,
        headerMain: 'How much can I borrow?',
        headerContent: '',
        forcePrev: false,
        prev: 'LoanPurposes',
        next: 'BorrowingInput',
    },
    DebtConsolidation: {
        isBlockDisplay: false,
        Component: DebtConsolidation,
        headerMain: 'Share a few details',
        headerContent: '',
        forcePrev: true,
        prev: 'LoanPurposes',
        next: 'BorrowingPower',
    },
    BorrowingInput: {
        isBlockDisplay: false,
        headerMain: 'Share a few details',
        headerContent: '',
        Component: BorrowingInput,
        prev: 'LoanPurposes',
        forcePrev: true,
        next: 'BorrowingPower',
    },
    BorrowingPower: {
        isBlockDisplay: true,
        headerMain: 'Your borrowing power',
        headerContent: '',
        Component: BorrowingPower,
        forcePrev: false,
        prev: 'BorrowingInput',
        next: null,
    },
};
